import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./GlobalAccountSearchRightPanel.css";
import { formatNumberInternational, pxToRem } from "../../../../utilities/uiUtils";
// Assuming this utility is available in your utilities folder
import { formatShortNumber } from "../../../../utilities/uiUtils";
import { useSelector } from "react-redux";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import ResizableDivForTag from "../../uiUtils/resizeobs/ResizableDivForTag";
import companyTypeMap from "../companyType.json";
import VisitLinkButton from "./VisitLinkButton.jsx";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp.jsx";
import GlobalAccountSearchSideCard from "./GlobalAccountSearchSideCard.jsx";
import TextWithTooltip from "../../GlobalContacts/TextWithTooltip.jsx";
import SaveToListModal from "../../GlobalContacts/SaveToListModal.jsx";
import PreSearchComp from "../../genericComponents/uiElements/PreSearchComp.jsx";
import IOSSpinner from "../../../HtmlElements/IOSSpinner.jsx";
import { useUser } from "../../../../context/UserContext.js";
import { getUserGlobalAccountsNameList, saveGlobalAccountsInList } from "../../../../services/iqApiV2.js";
import GenericFloatingBanner from "../../genericComponents/uiElements/GenericFloatingBanner.jsx";
function GlobalAccountSearchRightPanel({
  currentPage,
  itemsPerPage,
  handleOnPageChange,
  handleUpdateList
}) {

  const { user } = useUser();

  const { globalAccountsLoading, globalAccountsData } = useSelector(
    (state) => state.globalAccountsReducer
  );

  const commonProps = {};
  const [tabData, setTabData] = useState([]);
  const [currRow, setCurrRow] = useState();

  const [activeSwitchId, setActiveSwitchId] = useState(null);
  const tabConfig = [];
  const [activeTab, setActiveTab] = useState(tabConfig?.[0]?.key);
  const [showSideCard, setShowSideCard] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [selectedLists, setSelectedLists] = useState([]);
  const [accountsSaving, setAccountsSaving] = useState(false)
  const [accountLists, setAccountsLists] = useState([]);
  const [banner, setBanner] = useState(null);

  useEffect(() => {
      const fetchAccountListName = async() => {
        let accountLists = await getUserGlobalAccountsNameList(user?.id)
        setAccountsLists(accountLists || [])
      }
      if(user?.id){
        fetchAccountListName();
      }
  }, [user?.id])

  const triggerBanner = ({ message, type = "info", duration = 4000 }) => {

      setBanner({
        id: Date.now(),
        message,
        type,
        duration,
        title:""
      });
    };

  const buildSearchObj = () => ({
    
  });
  const initialListItems = []

  const prepareSaveListObj = (listObj) => {

    // 1) Get initial contacts for this list (if exists)
    const existingList = initialListItems.find(item => item.id === listObj.id);
    const existingContacts = existingList?.contacts || [];

    // 2) Convert selectedRows into map by ID for quick lookup
    const selectedContactMap = Object.fromEntries(
      selectedRows.map(c => [c.id, c])
    );

    // 3) Merge logic:
    // - If existing contact appears in selectedRows → update it
    // - Else keep as is
    const mergedContacts = existingContacts.map(oldContact => {
      if (selectedContactMap[oldContact.id]) {
        // update old contact with fresh selected data
        return {
          ...oldContact,
          ...selectedContactMap[oldContact.id]
        };
      }
      return oldContact;
    });

    // 4) Append NEW contacts that do not exist in existingContacts
    const existingIds = new Set(existingContacts.map(c => c.id));
    selectedRows.forEach(sel => {
      if (!existingIds.has(sel.id)) {
        mergedContacts.push(sel); // append new
      }
    });

    // 5) Base payload
    const base = {
      user_id: user?.id,
      name: listObj?.name,
      company_ids: selectedRows.map(row => row.companyid),
      // filters: {
      //   additionalProp1: {
      //     ...buildSearchObj(),
      //     contacts: mergedContacts   // <-- send merged here
      //   }
      // }
    };
    return base;
  };

  const handleSideCard = useCallback((e, item, tabId) => {
    // console.log(item._id)
    e.preventDefault();
    e.stopPropagation();
    setShowSideCard(true);

    setCurrRow(item);
    setActiveTab(tabId || "nuture_activity");
  }, []);

  // State to track selected rows
  const [selectedRows, setSelectedRows] = useState([]);

  // Data for calculations
  const totalAccounts = globalAccountsData ? globalAccountsData?.numFound : 0;
  const selectedCount = selectedRows.length;

  const tableColumns = useMemo(
    () => [
      {
        id: "generic-check-box",
        // Adjusted width to match the contact table for consistency
        width: "1rem",
      },
      {
        id: "company_name",
        label: "Name",
        width: 100,
        clickAction: true,
        alignment: "left",
      },
       {
        id: "description",
        label: "Description",
        width: 120,
        clickAction: true,
        alignment: "left",
      },
      {
        id: "industries",
        label: "Industries",
        width: 70,
        alignment: "flex-start",
      },
      {
        id: "yearfounded",
        label: "Founded In",
        width: 70,
        alignment: "flex-start",
      },
      {
        id: "companytypeid",
        label: "Type",
        width: 100,
        alignment: "flex-start",
      },
      {
        id: "country",
        label: "Country",
        width: 60,
        alignment: "flex-start",
      },
      {
        id: "region",
        label: "Region",
        width: 100,
        alignment: "flex-start",
      },
      {
        id: "webpage",
        label: "Website",
        width: 60,
        alignment: "flex-start",
      },

      {
        id: "employees",
        label: "Employees",
        width: 60,
        alignment: "flex-start",
      },
    ],
    [globalAccountsData?.docs]
  );

  useEffect(() => {
    const filtered = globalAccountsData?.docs;

    const enhanced = filtered?.map((item) => ({
      ...item,
      company_name: (
        
        <span onClick={(e) => handleSideCard(e, item)}>
        <TextWithTooltip  className = "two-line-ellipsis_companyname" text={item?.company_name}/>
        </span>
      ),
      description: (
        <TextWithTooltip
          className={"two-line-ellipsis"}
          text={item?.description?.[0]}
        />
      ),
      // Ensure there is a unique ID for selection to work
      id: item.id || item._id,

      industries: (
        <ResizableDivForTag
          handleSideCard={(e) => handleSideCard(e, item)}
          items={(Array.isArray(item?.industries)
            ? item?.industries
            : typeof item?.industries === "string"
            ? item?.industries.split(",")?.map((s) => s.trim())
            : []
          )?.map((e) => ({ key: e, label: e }))}
          rowData={item}
        />
      ),
      companytypeid: (
        <TextWithTooltip
          className="one-line-ellipsis-companytype"
          text={
            Array.isArray(item?.companytypeid)
              ? item?.companytypeid
                  .map((id) => companyTypeMap?.[id] || `Unknown (${id})`+new Date().getTime())
                  .join(", ")
              : companyTypeMap[item?.companytypeid] || item?.companytypeid || ""
          }
        />
      ),
      region:<TextWithTooltip
          className={"two-line-ellipsis"}
          text={item?.region}
        />,
      country:<TextWithTooltip
          className={"two-line-ellipsis"}
          text={item?.country}
        />,

      webpage:  <TextWithTooltip
          className={"one-line-ellipsis"}
          text={item?.webpage}
        />,
      employees: <TextWithTooltip
          className={"two-line-ellipsis"}
          text={item?.employees ? Math.round(item?.employees) : ""}
        />,
    }));

    setTabData(enhanced);
    console.log("globalAccountsData", globalAccountsData);
  }, [globalAccountsData]);

  return (
    <div
      className="gasrp_wrapper"
      style={{ width: pxToRem(1500) }}
    >
      {/* 🚀 START: Taskbar - Styles moved to CSS for better control */}
      <div
        className="gasrp-container-table-top"
        style={
          // Cleared inline styles for layout and padding.
          // Only necessary inline styles remain (if any were here).
          // Removed all explicit inline styles here so CSS takes over.
          {}
        }
      >
        {banner && (
          <GenericFloatingBanner
            key={banner.id}
            message={banner.message}
            title={banner.title}
            type={banner.type}
            duration={banner.duration}
            onClose={() => setBanner(null)}
          />
        )}
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            gap: "1.5rem",
            position: 'relative'
          }}
        >
          {selectedCount > 0 && (
            <>
              {/* Clear Selected: Black and not underlined */}
              <div
                style={{
                  fontSize: "12.8px",
                  cursor: "pointer",
                  color: "black",
                }}
                onClick={() => setSelectedRows([])}
              >
                Clear Selected ({selectedCount})
              </div>

              {/* Save To List Button: Hardcoded appearance */}
              <div className="save-list-btn-wrapper">
              <button
                style={{
                  fontSize: "12.8px",
                  padding: "4px 8px",
                  border: "none",
                  borderRadius: "4px",
                  backgroundColor: "#e4edf7ff",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowListModal(true)
                }}
               >
                Save To List
              </button>

              {showListModal && (
                  <SaveToListModal

                    title="Account List"
                    buttonText="Save Selected Accounts"
                    contactLists={accountLists}
                    setContactLists={setAccountsLists}
                    show={showListModal}
                    onClose={async () => { setShowListModal(false) }}
                    onSave={async (selectedLists) => {
                      try {
                        setAccountsSaving(true);
                        console.log(
                          "selectedLists",
                          initialListItems,
                          selectedLists
                        );

                        const payloads = selectedLists.map((listObj) =>
                          prepareSaveListObj(listObj)
                        );

                        // Run all API calls in parallel and wait for all of them
                        await Promise.all(
                          payloads.map((element) =>
                            saveGlobalAccountsInList(element)
                          )
                        );

                        // Call only after ALL list saves are complete
                        // await postOnSave();

                        // const initialListItems = { initialListItems };

                        setShowListModal(false);
                        setSelectedRows([]);
                        handleUpdateList()

                        triggerBanner({
                          message: "Saved To List",
                          type: "success",
                          duration: 10000,
                        });
                      } catch (error) {
                        console.log("ERRRORRRR : ", error)

                        triggerBanner({
                          message: "Unexpected Error",
                          type: "error",
                          duration: 10000,
                        });

                      } finally {
                        setAccountsSaving(false);
                      }

                    }}
                  />
                )}
                </div>
            </>
          )}
        </div>

        {/* Total Accounts Count - Always right-aligned */}
      {  globalAccountsLoading ? <IOSSpinner/> :<div
          style={{
            flexShrink: 0,
            fontSize: "0.9rem",
            fontWeight: "500",
            textAlign: "right",
          }}
        >
          Total {formatNumberInternational(totalAccounts)}
        </div>}
      </div>

      {tabData?.length === 0 && !globalAccountsLoading ? (
  <PreSearchComp title="Accounts"/>
) : (
      <GenericTable
        disableSort={true}
        enablePagination={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onPageChange={handleOnPageChange}
        totalItems={totalAccounts}
        initialColumns={tableColumns}
        tabData={tabData}
        onModalClose={() => {}}
        loading={globalAccountsLoading}
        allowSelection={true}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        loadingRows={15}
        minWidthForDrawer={"60%"}
        setShowMoreModal={setShowSideCard}
        showMoreModal={showSideCard}
        titleForSideCard={
          <ScHeaderComp
            key={`side_card_global_acc_head_comp`}
            type="auto_nurture"
            opportunityId={commonProps?.opportunityId}
            data={currRow}
            titlkey={"objective"}
            titlTxt={currRow?.company_name}
            setShowMoreModal={setShowSideCard}
            activeTab={activeTab}
          />
        }
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeSwitchId={activeSwitchId}
        customComp={<GlobalAccountSearchSideCard data={currRow} />}
      />)}
      {/* {showListModal && (
  
  <SaveToListModal
  show={showListModal}
  onClose={() => setShowListModal(false)}
  onSave={(selectedLists) => {
    console.log(
      "Saving selected contacts:",
      selectedRows,
      "to lists:",
      selectedLists
    );
    setShowListModal(false);
    setSelectedLists([]);
    setSelectedRows([]);
  }}
  initialLists={[
    "Marketing Leads",
    "Product Managers",
    "VIP Contacts",
    "Chief Executive Officers",
    "Chief Growth Officer",
    "Chief Product Officer",
    "Chief Business Officer",
    "Vice Presidents",
  ]}
  title = {"Save to Accounts List"}
/>

)} */}
    </div>
  );
}

export default GlobalAccountSearchRightPanel;
